import { useErrorNotificationApi } from '@equifinance/shared';
import {
  Checklist,
  ChecklistRequest,
  ChecklistNotePayload,
  ChecklistOverrideProductPayload,
  UploadChecklistDocumentPayload,
  SendOfferPayload,
} from '../contexts/checklist';

const apiPath = `${process.env.REACT_APP_ORIGINATION_API_PATH}/`;

const apiUrl = (path: string) => `${apiPath}${path}`;

export type ChecklistApiType = {
  getChecklist: (id: string) => Promise<Checklist>,
  putChecklist: (checklist: ChecklistRequest, accountId: string) => Promise<Checklist>,
  postNote: (payload: ChecklistNotePayload, accountId: string) => Promise<Checklist>,
  postOverrideProduct: (payload: ChecklistOverrideProductPayload, accountId: string) => Promise<Checklist>,
  uploadDocuments: (applicationId: string, documentPayload: UploadChecklistDocumentPayload) => Promise<Checklist>,
  postSendOffer: (applicationId: string, sendOfferPayload: SendOfferPayload) => Promise<Checklist>,
  postCancelOffer: (applicationId: string) => Promise<Checklist>,
  postResendOffer: (applicationId: string, sessionId: string) => Promise<Record<string, any> | undefined>,
}

export default function useChecklistApi(): ChecklistApiType {
  const {
    get, put, post,
  } = useErrorNotificationApi(apiUrl);

  return {
    getChecklist: (id: string): Promise<Checklist> => get(`checklists/${id}`),
    putChecklist: (checklist: ChecklistRequest, accountId: string) => put(`checklists/${accountId}`, checklist),
    postNote: (payload: ChecklistNotePayload, accountId: string) => post(`checklists/${accountId}/notes`, payload),
    postOverrideProduct: (payload: ChecklistOverrideProductPayload, accountId: string) => post(`checklists/${accountId}/override/product`, payload),
    uploadDocuments: (applicationId: string, documentPayload: UploadChecklistDocumentPayload) => post(`checklists/${applicationId}/document`, documentPayload),
    postSendOffer: (applicationId: string, sendOfferPayload: SendOfferPayload) => post(`checklists/${applicationId}/offer`, sendOfferPayload),
    postCancelOffer: (applicationId: string) => post(`checklists/${applicationId}/cancel-offer`, {}),
    postResendOffer: (applicationId: string, sessionId: string) => post(`checklists/${applicationId}/resend-offer`, { sessionId }),
  };
}
